import React from 'react';

import { cn } from '@lyearn/style';
import VirtualizedList from '@/components/VirtualizedList';

import { useListContext } from '../..';
import { ItemsProps } from '../../types';
import { listContainerStyles } from './styles';

function Items(props: ItemsProps) {
  const { className, style, withPagination = false, renderer } = props;
  const { items, fetchMore } = useListContext();

  if (!items?.length) {
    return null;
  }

  if (withPagination) {
    return (
      <VirtualizedList
        className={cn(className, listContainerStyles)}
        data={items}
        endReached={fetchMore}
        itemContent={renderer}
        style={style}
      />
    );
  }

  return <>{items.map((_, index) => renderer(index))}</>;
}

export default React.memo(Items);
